module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('div', {
    staticClass: "product-details-page"
  }, [_c('div', {
    staticClass: "product-details-content"
  }, [(!_vm.loading && !_vm.error && _vm.product) ? _c('div', {
    staticClass: "product-details-back-wrap"
  }, [_c('button', {
    staticClass: "product-details-back-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.navigateBackToList
    }
  }, [_vm._v("\n        ← " + _vm._s(_vm.backNavigationLabel) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-container"
  }, [_c('div', {
    staticClass: "ui active loader"
  }), _vm._v(" "), _c('p', [_vm._v("Loading product details...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-container"
  }, [_c('i', {
    staticClass: "exclamation triangle huge icon"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('div', {
    staticClass: "error-actions"
  }, [_c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.goToAlerts
    }
  }, [_vm._v("View All Alerts")]), _vm._v(" "), _c('button', {
    staticClass: "ui button",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Go Back")])])]) : (_vm.product) ? _c('div', {
    staticClass: "product-content-grid"
  }, [_c('div', {
    staticClass: "grid-full"
  }, [_c('ProductHeader', {
    attrs: {
      "product": _vm.product
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full"
  }, [_c('CurrentOffers', {
    attrs: {
      "offers": _vm.product.currentOffers,
      "marketplace": _vm.product.marketplace
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full"
  }, [_c('SalesVolumeChart', {
    attrs: {
      "salesData": _vm.product.salesVolume,
      "marketplace": _vm.product.marketplace
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full",
    class: {
      'two-column': _vm.reviewHealthVisible
    }
  }, [_c('ListingSignals', {
    attrs: {
      "signals": _vm.product.listingSignals
    }
  }), _vm._v(" "), (_vm.reviewHealthVisible) ? _c('ReviewHealth', {
    attrs: {
      "reviewHealth": _vm.product.reviewHealth
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "grid-full two-column"
  }, [_c('AccountHealth', {
    attrs: {
      "accountHealth": _vm.product.accountHealth,
      "isFeaturedMerchant": _vm.product.isFeaturedMerchant
    }
  }), _vm._v(" "), _c('RecentEvents', {
    attrs: {
      "events": _vm.product.recentEvents
    },
    on: {
      "period-changed": _vm.handleRecentEventsPeriodChange
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1409635e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetailsPage.vue
// module id = 727
// module chunks = 2